/* eslint-disable react/prop-types */

/* eslint-disable camelcase */
// DataDetails.jsx

import React from 'react'
import {
  injectIntl,
  FormattedMessage,
} from 'react-intl'
import PropTypes from 'prop-types'

import styles from '../../../../../css/home.module.css'
import settingStyles from '../../../../../css/settings.module.css'
import { CapitalButton } from '../../Navigation/Buttons'
import stylesButton from '../../../../../css/devicePage.module.css'

function DataDetails (props) {
  const {
    data,
    params: {
      deviceID,
    },
    intl: {
      formatMessage,
    },
  } = props

  const { lookup } = data
  const device = lookup[deviceID]

  const {
    physical: {
      geom, canopy, deviceType, property_id, lnglat,
    },
  } = device

  const toExternalData = () => {
    window.open(`https://live.semios.com/weather/${property_id}?geom=${geom}`, '_blank').focus()
  }

  let position = canopy

  if (position === 'ABOVE') {
    position = 'Above Canopy'
  } else if (position === 'BELOW') {
    position = 'Below Canopy'
  } else if (position === 'IN') {
    position = 'In Canopy'
  }

  const breakDownLngLat = lnglat.match(/[-+]?[0-9]*\.?[0-9]+/g)
  const lng = breakDownLngLat[0]
  const lat = breakDownLngLat[1]

  const { saveButton } = stylesButton

  const saveButtonStyle = `${saveButton} saveButton`

  return (
    <>
      <div>
        <div className={`${styles.userInviteInput} ${settingStyles.modemReplacementContainer} ${settingStyles.dataContainer}`}>
          <FormattedMessage
            id='settings.dataDetails.dataType'
            defaultMessage='Data Type'
            description='Data Type label'
            tagName='h4'
          />
          <h2 className={settingStyles.deviceType}>{deviceType}</h2>

          <FormattedMessage
            id='settings.dataDetails.source'
            defaultMessage='Source'
            description='Source label'
            tagName='h4'
          />
          <h2>Semios</h2>

          <FormattedMessage
            id='settings.dataDetails.sourceDeviceID'
            defaultMessage='Source Device ID'
            description='Source Device ID label'
            tagName='h4'
          />
          <h2>{geom}</h2>

          <FormattedMessage
            id='settings.dataDetails.position'
            defaultMessage='Position'
            description='Position label'
            tagName='h4'
          />
          <h2>{position}</h2>

          <FormattedMessage
            id='settings.dataDetails.propertyID'
            defaultMessage='Property ID'
            description='Property ID label'
            tagName='h4'
          />
          <h2>{property_id}</h2>

          <FormattedMessage
            id='settings.dataDetails.location'
            defaultMessage='Location'
            description='Location label'
            tagName='h4'
          />
          <p className={settingStyles.lat}>
            LNG:
            {' '}
            {lng}
          </p>
          <p className={settingStyles.lng}>
            LAT:
            {' '}
            {lat}
          </p>

        </div>
      </div>
      <CapitalButton
        text={formatMessage({
          id: 'setting.semiosData',
          defaultMessage: 'Semios Data',
          description: 'Semios Data',
        })}
        buttonFunction={toExternalData}
        hSize='h2'
        style={saveButtonStyle}
      />

    </>

  )
}

DataDetails.propTypes = {
  params: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
}

export default injectIntl(DataDetails)
